import React, { PureComponent } from 'react';
import * as _ from 'lodash';
import { getTrackBackground, Range } from 'react-range';

import styles from './NewRangeInput.module.scss';

interface NewRangeInputProps {
  min: number;
  max: number;
  minLabel?: string | JSX.Element;
  maxLabel?: string | JSX.Element;
  step: number;
  values: number[];
  onChange: (values: number[]) => void;
  trackColorStart?: string;
  trackColorEnd?: string;
  labelThumbColor?: string;
  thumbColor?: string;
  minMaxLabelColor?: string;
}

interface NewRangeInputState {
  rangeInputValues: number[];
}

// TODO Не забыть изменить название
export default class NewRangeInput extends PureComponent<NewRangeInputProps, NewRangeInputState> {
  constructor({ props }: { props: any }) {
    super(props);
    this.state = {
      rangeInputValues: [],
    };
  }

  public componentDidMount(): void {
    const { values } = this.props;
    this.setState({ rangeInputValues: values });
  }

  public componentDidUpdate(prevProps: NewRangeInputProps): void {
    if (this.props.values.toString() !== prevProps.values.toString()) {
      this.setState({ rangeInputValues: this.props.values });
    }
  }

  private readonly changeHandler = (rangeInputValues: number[]) => {
    const { onChange } = this.props;
    this.setState({ rangeInputValues });
    onChange(rangeInputValues);
  };
  private readonly getTrackColor = (length: number) => {
    const colors: string[] = [];
    for (let i = 0; i < length - 1; i++) {
      colors.push('#6AC3FA');
    }
    return colors;
  };

  public render() {
    const { rangeInputValues } = this.state;
    const {
      min,
      max,
      minLabel,
      maxLabel,
      step,
      trackColorEnd,
      trackColorStart,
      labelThumbColor,
      minMaxLabelColor,
      thumbColor,
    } = this.props;
    // в Range thumbRefs создаются в зависимости от количества values и только при создании компонента!!!
    if (rangeInputValues.length === 0) {
      return null;
    }

    return (
      <div>
        <div>
          <Range
            step={step}
            min={min}
            max={max}
            renderTrack={({ props, children }) => (
              <div
                onMouseDown={props.onMouseDown}
                onTouchStart={props.onTouchStart}
                style={{
                  ...props.style,
                  height: '36px',
                  display: 'flex',
                  width: '100%',
                  position: 'relative',
                }}
              >
                <div
                  ref={props.ref}
                  style={{
                    height: '3px',
                    width: '100%',
                    borderRadius: '4px',
                    background: getTrackBackground({
                      values: rangeInputValues,
                      colors: _.flattenDeep([
                        trackColorStart ? trackColorStart : '#FFFFFF',
                        this.getTrackColor(this.props.values.length),
                        trackColorEnd ? trackColorEnd : '#FFFFFF',
                      ]),
                      min,
                      max,
                    }),
                    alignSelf: 'center',
                  }}
                >
                  {children}
                </div>
              </div>
            )}
            renderThumb={({ index, props }) => (
              <div
                {...props}
                className={styles.range_input__thumb}
                style={{
                  ...props.style,
                  cursor: 'pointer',
                  backgroundColor: thumbColor && thumbColor,
                }}
              >
                <div
                  className={styles.range_input__thumb_label}
                  style={{ color: labelThumbColor && labelThumbColor }}
                >
                  {rangeInputValues[index]}
                </div>
              </div>
            )}
            onChange={this.changeHandler}
            values={rangeInputValues}
          />
        </div>
        <div className={styles.range_input__min_max_label__container}>
          <span
            className={styles.range_input__min_max_label}
            style={{ color: minMaxLabelColor && minMaxLabelColor }}
          >
            {minLabel ? minLabel : min}
          </span>
          <span
            className={styles.range_input__min_max_label}
            style={{ color: minMaxLabelColor && minMaxLabelColor }}
          >
            {maxLabel ? maxLabel : max}
          </span>
        </div>
      </div>
    );
  }
}
